<svg class="cm-svg cm-svg-h" width="0" height="0" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <marker [attr.id]="arrowLeftId" viewBox="0 0 10 10" refX="1" refY="5" markerWidth="4" markerHeight="4" orient="auto">
            <path d="M 10 0 L 0 5 L 10 10 z" fill="#b3b3b3" />
        </marker>
        <marker [attr.id]="arrowRightId" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="4" markerHeight="4" orient="auto">
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#b3b3b3" />
        </marker>
    </defs>
    @if (!$hideLabels()) {
        <text x="50%" y="11" text-anchor="middle" font-family="sans-serif" font-size="13" fill="#888888">{{ $widthLabel() }}</text>
    }
    <line
        x1="0"
        y1="18"
        x2="100%"
        y2="18"
        stroke="#b3b3b3"
        stroke-width="1.5"
        [attr.marker-start]="'url(#' + arrowLeftId + ')'"
        [attr.marker-end]="'url(#' + arrowRightId + ')'"
    />
</svg>
<svg class="cm-svg cm-svg-v" width="0" height="0" style="overflow: visible" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <marker [attr.id]="arrowTopId" viewBox="0 0 10 10" refX="5" refY="1" markerWidth="4" markerHeight="4" orient="0">
            <path d="M 5 0 L 10 10 L 0 10 z" fill="#b3b3b3" />
        </marker>
        <marker [attr.id]="arrowBottomId" viewBox="0 0 10 10" refX="5" refY="9" markerWidth="4" markerHeight="4" orient="0">
            <path d="M 5 10 L 0 0 L 10 0 z" fill="#b3b3b3" />
        </marker>
    </defs>
    @if (!$hideLabels()) {
        <text
            x="11"
            y="50%"
            text-anchor="middle"
            dominant-baseline="central"
            font-family="sans-serif"
            font-size="13"
            fill="#888888"
            style="transform-origin: 8px 50%; transform: rotate(-90deg)"
        >
            {{ $heightLabel() }}
        </text>
    }
    <line
        x1="18"
        y1="0"
        x2="18"
        y2="100%"
        stroke="#b3b3b3"
        stroke-width="1.5"
        [attr.marker-start]="'url(#' + arrowTopId + ')'"
        [attr.marker-end]="'url(#' + arrowBottomId + ')'"
    />
</svg>
<div class="cm-body"><ng-content></ng-content></div>
